import kolonaSlider from './kolonaSliderInit';
import kolonaHeroSection from './kolonaHeroSection';
import kolonaMarquee from './kolonaMarquee';

kolonaSlider();
kolonaHeroSection();
kolonaMarquee();
